import * as React from 'react'
import { connect } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import { checklistUpdateComponent } from '../../../../redux/actions'
import FormComponentBuilder from '../FormComponent/FormComponentBuilder'

export interface ComponentData {
  id: string
  optional: boolean
  type: {
    type: string
    options: string[]
  }
  defaultValue: string
  lastValue: string
}

export interface StateProps {
  componentData: ComponentData
  checklistInstanceId: string
  checkId: string
}

export interface DispatchProps {
  updateComponent: (
    checklistInstanceId: string,
    componentId: string | undefined,
    value: Array<{ subComponentName: string; value: number }> | string | number | undefined,
    conclude: boolean
  ) => Promise<any>
}

export interface OwnProps {
  collapseHandler?: Function
}

export type Props = StateProps & DispatchProps & OwnProps & WithTranslation

const mapDispatchToProps = (dispatch: Function): DispatchProps => {
  return {
    updateComponent: (checklistInstanceId, componentId, value, conclude) =>
      dispatch(checklistUpdateComponent(checklistInstanceId, componentId, value, conclude)),
  }
}

export class SelectComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    this.updateComponent = this.updateComponent.bind(this)
    this.manageCollapsable = this.manageCollapsable.bind(this)
    this.manageCollapsable()
  }

  private manageCollapsable() {
    if (this.props.componentData.lastValue && this.props.componentData.optional && this.props.collapseHandler) {
      this.props.collapseHandler()
    }
  }

  private updateComponent(event: React.ChangeEvent<HTMLSelectElement>) {
    event.persist()
    this.props.updateComponent(this.props.checklistInstanceId, this.props.componentData.id, event.target.value, false)
  }

  public render() {
    return (
      <FormComponentBuilder<string> component={this.props.componentData}>
        {({ className, onBlur, disabled, value: currentValue }) => {
          return (
            <select
              className={`custom-select ${className}`}
              onBlur={onBlur}
              disabled={disabled}
              onChange={this.updateComponent}
              value={currentValue}
            >
              {this.props.componentData.type.options.map(option => (
                <option key={`option-${option}`} value={option}>
                  {option}
                </option>
              ))}
            </select>
          )
        }}
      </FormComponentBuilder>
    )
  }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SelectComponent))
